import {addDays, endOfMonth, format, startOfMonth, subDays} from "date-fns";
import {Bar, Line} from "react-chartjs-2";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Field} from "../../../../components/fouladyar/field/field";
import annotationPlugin from "chartjs-plugin-annotation";
import {CategoryScale, Chart as ChartJS, Legend,BarController, LinearScale,BarElement, LineElement, PointElement, Tooltip} from "chart.js";

ChartJS.register(BarElement,BarController, LineElement, CategoryScale,annotationPlugin, LinearScale, PointElement, Tooltip, Legend);

export default function MaximumDrawdownInSingleDayLineChartComponent ({orderDetail, initialCapital}) {




    //-----------new code----------------
    // Extract data for the chart
    const labels = Object.keys(orderDetail?.equity); // Dates
    const lowestEquityData = labels.map(date => orderDetail?.equity[date]?.lowestEquity === 0 ? orderDetail?.equity[date]?.highestEquity : orderDetail?.equity[date]?.lowestEquity);
    const lastEquityData = labels.map(date => orderDetail?.equity[date]?.lastEquity === 0 ? orderDetail?.equity[date]?.highestEquity : orderDetail?.equity[date]?.lastEquity );

    const data = {
        labels,
        datasets: [
            {
                label: 'Lowest Equity',
                data: lowestEquityData,
                borderColor: 'rgba(248,43,86,0.89)',
                fill: false,
                borderWidth: 2,
                tension: 0.2
            },
            {
                label: 'Last Equity',
                data: lastEquityData,
                borderColor: 'rgba(0,255,168,0.82)',
                fill: false,
                borderWidth: 2,
                tension: 0.2
            }
        ]
    };


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {},
        scales: {
            x: {
                title: { display: true, text: 'Date' },
                grid: { display: false }
            },
            y: {
                title: { display: true, text: 'Equity Value' }
            }
        }
    };


    return (
        <table border="1" cellPadding="10" className="w-100 mb-3">
            <thead>
            <tr>
                <th className="d-flex flex-row justify-content-between align-center">

                    <span>نمودار دراودان روزانه</span>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <div style={{width: '100%', height: '400px'}}>
                    <Line data={data} options={options}/>
                </div>
            </tr>

            </tbody>
        </table>
    )


}
